import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import LeavePageModal from "./LeavePageModal";
import { ModalCloseIcon } from "../../constants/svg";

const GenericModal = (props) => {
  const {
    show,
    size,
    modalTitle,
    bodyComponent,
    setModalShow,
    disableLeaveConfirmation = false,
    customModalHeader,
    customClassName,
    desc,
    modalDesc,
    pro,
    goal,
    mt10,
    resetForm,
    // intentionally omit the rest so they are not forwarded to the DOM Modal
  } = props;

  const [leavePagemodalShow, setLeavePageModalShow] = useState(false);

  const requestClose = () => {
    if (disableLeaveConfirmation) {
      setModalShow?.(false);
      return;
    }
    setLeavePageModalShow(true);
  };

  return (
    <>
      <Modal
        show={show}
        size={size}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className={`resource-modal generic-modal ${customClassName || ""}`}
        style={leavePagemodalShow ? { opacity: "0.75" } : {}}
        onHide={requestClose}
      >
        <Modal.Header
          style={{
            paddingBottom: goal == true ? "25px" : "30px",
            background: "#f5f6f8",
          }}
          className={`${customModalHeader || ""}`}
        >
          <Modal.Title
            id="contained-modal-title-vcenter"
            className="text-center w-100 pd-left-40"
          >
            {modalTitle}
          </Modal.Title>

          <div
            className="closeBtn"
            data-bs-dismiss="modal"
            onClick={requestClose}
          >
            <ModalCloseIcon />
          </div>
        </Modal.Header>
        {desc == true ? (
          <div className="text-left location-desc-padding custom-height-20 custom-fs-15">
            <b>{pro}</b> {modalDesc}
          </div>
        ) : (
          <div
            className="text-center pb-4 font-size-13"
            style={{ display: modalDesc ? "block" : "none" }}
          >
            {modalDesc}
          </div>
        )}

        <div className={mt10}>{bodyComponent}</div>
        <LeavePageModal
          show={leavePagemodalShow}
          onHide={() => setLeavePageModalShow(false)}
          setModalShow={setModalShow}
          resetForm={resetForm}
        />
      </Modal>
    </>
  );
};

export default GenericModal;
